import { Box, Typography } from '@mui/material';
import React, { FunctionComponent, useMemo } from 'react';
import TinderCard from 'react-tinder-card';

import { MyUntargetedUsersQuery } from '../../apollo/__generated__/graphql';
import { Direction } from '../../tinders/pages/Tinders/components/TinderSwipe/useTinderSwipe';
import { useUserCard } from './useUserCard';

interface UserCardProps {
  cardRef: React.RefObject<{
    swipe(dir?: Direction): Promise<void>;
    restoreCard(): Promise<void>;
  }>;
  user: MyUntargetedUsersQuery['myUntargetedUsers'][number];
  onSwipe: (direction: Direction) => void;
  currentImageIndex: number;
  currentIndex: number;
  index: number;
  canSwipeUp?: boolean;
}

export const UserCard: FunctionComponent<UserCardProps> = ({
  cardRef,
  user,
  onSwipe,
  currentImageIndex,
  currentIndex,
  index,
  canSwipeUp = false,
}) => {
  const { currentImage } = useUserCard(user, currentImageIndex);

  const backgroundImage = useMemo(() => {
    return currentImage ? 'url(' + currentImage.url + ')' : undefined;
  }, [currentImage, currentIndex, index]);

  if (index > currentIndex + 2) {
    return null;
  }

  return (
    <TinderCard
      ref={cardRef}
      className="swipe"
      onSwipe={onSwipe}
      swipeRequirementType="position"
      flickOnSwipe
      preventSwipe={canSwipeUp ? ['down'] : ['up', 'down']}
    >
      <Box
        sx={{
          position: 'relative',
          backgroundColor: 'white',
          borderRadius: 4,
          height: '450px',
          width: '300px',
          backgroundImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          px: 2,
          py: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '50%',
            background:
              'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0))',
            borderBottomLeftRadius: 16,
            borderBottomRightRadius: 16,
            pointerEvents: 'none',
            zIndex: 1,
          }}
        />

        <Box sx={{ pointerEvents: 'none', zIndex: 2 }}>
          <Typography variant="h5" color="white">
            {user.firstname}
            {user.nickname ? ` "${user.nickname}"` : null}
          </Typography>
          <Typography variant="h6" color="white">
            {user.studies} {user.studyTown}
          </Typography>
        </Box>
      </Box>
    </TinderCard>
  );
};
